
var $ctaBottomNav = $('.js-cta-bottom-nav');
var point = $('.js-cta-hero').offset();

function VisibleCtaBottomNav() {
  if ($(window).scrollTop() > point.top) {
    $ctaBottomNav.addClass("is-visible");
  }
  else {
    $ctaBottomNav.removeClass("is-visible");
  }
}

VisibleCtaBottomNav();
$(window).scroll(function () {
  VisibleCtaBottomNav();
});

export { VisibleCtaBottomNav };
